export default "__VITE_ASSET__fV0lrimC__"